// 引入状态管理
// 引入路由
import store from '../../vuex/store';
const auth = {
    inserted(el, binding) {
        var ruleslist = store.state.ruleslist;
        if (ruleslist && !ruleslist.length) {
            ruleslist = JSON.parse(localStorage.getItem('rules'));
        }
        if(ruleslist && ruleslist.length){
            let v = ruleslist.find(item => item === binding.value)
            if (!v) {
                //移除元素
                el.parentNode.removeChild(el)
            }
        }
    }
}

auth.install = function (Vue) {
    //定义指令名
    Vue.directive('auth', auth)
}

export default auth


// WEBPACK FOOTER //
// ./src/directive/auth/index.js